import { ofType } from "redux-observable";
import { map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionInventoryInfoReceived } from "./actionInventoryInfo";
export var epicInventoryInfo = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps.netSend({
            id: CommandCode.InventoryInfo,
            props: {
                playerId: action.playerId,
            },
        });
    }), retry(), map(function (res) { return actionInventoryInfoReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/inventory/epicInventoryInfo.ts
// module id = 835
// module chunks = 3